module.exports = __webpack_public_path__ + "static/img/logo-min.8886542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-min.png
// module id = uoKR
// module chunks = 1